import React, { useCallback, useEffect, useRef, useState } from "react";
import "./supplierAndManufacturers.scss";
import PageHeader, { FILTER_OPTIONS } from "./Components/PageHeader";
import PageBody from "./Components/PageBody";
import AddEditSupplierAndManufacturers from "./modals/AddEditSupplierAndManufacturers";
import { useAuth } from "../../context/Auth";
import { postRequest } from "../../../Utils/commonApi";
import { CallToast } from "../../PriceCalculator/modals/CustomToast";
import ContentLoader from "react-content-loader";
import { Entities } from "../../../common/store/entities/entities.enum";
import { useEntity } from "../../../hooks/use-entity.hook";
import useActions from "../../../hooks/service-actions.hook";
import { SuppliersAndManufacturersEffectActions } from "../../../common/services/suppliers-and-manufacturers/suppliers-and-manufacturers.service";
import Loader from "react-spinners/ClipLoader";

export const HeadersTabsValues = [{
  pageId: 0,
  name: 'For My MSP',
},
{
  pageId: 1,
  name: 'For My Clients',
}];

const SupplierAndManufacturers = ({ isView: isViewParam = false }) => {
  const divRef = useRef();
  const { authTokens } = useAuth();
  const hasCalledAPI = useRef(false); // track whether API was already called

  const [selectedTab, setSelectedTab] = useState(HeadersTabsValues[0]);
  const [showAddEditSupplierAndManufacturersModal, setShowAddEditSupplierAndManufacturersModal] = useState(false);
  const [isView, setIsView] = useState(isViewParam);
  const [myMspTableData, setMyMspTableData] = useState([]);
  const [sortOrder, setSortOrder] = useState(1);
  const [selectedItemId, setSelectedItemId] = useState(0);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedClientId, setSelectedClientId] = useState(0);
  const [headersList, setHeadersList] = useState([]);
  const [filters, setFilters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchString, setSearchString] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const { getAllSuppliersAndManufacturers } = useActions(SuppliersAndManufacturersEffectActions);
  const { entityData: suppliersAndManufacturersList } = useEntity({ entityType: Entities.SuppliersAndManufacturers/*, entityId: clientId*/ });

  useEffect(() => {
    if (!suppliersAndManufacturersList) return;
    setMyMspTableData(suppliersAndManufacturersList);
    setHeadersList(suppliersAndManufacturersList?.MSPClientSortVisibility_List);
    setPageNumber(suppliersAndManufacturersList?.SupplierNumber);
    setLoading(Loader.getAllSuppliersAndManufacturers)
  }, [suppliersAndManufacturersList, Loader.getAllSuppliersAndManufacturers]);
  
  useEffect(() => {
    getMSPAllSupplierManufacturer();
  }, [selectedTab])

  const handleScroll = useCallback(() => {
    if ((selectedTab?.pageId === 0 ? myMspTableData?.MSPClientRowData_List : myMspTableData?.ClientRowData_List)?.length < myMspTableData?.TotalSupplier) {
      const div = divRef.current;
      const atBottom = div.scrollTop + div.clientHeight + 1 >= div.scrollHeight;

      if (atBottom && !hasCalledAPI.current) {
        hasCalledAPI.current = true; // prevent further calls
        getMSPAllSupplierManufacturer({}, pageNumber);
      } else if (!atBottom) {
        hasCalledAPI.current = false; // reset when user scrolls up
      }
    }
  }, [pageNumber, myMspTableData]);


  const onPageClick = (number = 1) => {
    getMSPAllSupplierManufacturer({}, number === 1 ? 0 : (number * 10 - 9));
  }

  const onArrowClick = (isNext = true) => {
    if (isNext) {
      getMSPAllSupplierManufacturer({}, suppliersAndManufacturersList?.SupplierNumber);
    } else {
      getMSPAllSupplierManufacturer({}, suppliersAndManufacturersList?.SupplierNumber === 0 ? ((Math.ceil(suppliersAndManufacturersList?.TotalSupplier / 10) - 1) * 10 - 9) :
        suppliersAndManufacturersList?.SupplierNumber - 10 === 1 ? 0 : suppliersAndManufacturersList?.SupplierNumber - 20
      );
    }
  }


  const getMSPAllSupplierManufacturer = (data, number = 0) => {
    getAllSuppliersAndManufacturers({
      isForClientPage: selectedTab?.pageId !== 0,
      body: {
        ObjectId: 0,
        SupplierNumber: number ?? 0,
        MSPSupplierFilter_List: data?.filters?.length > 0 ? JSON.stringify(data?.filters ?? [
          { MSPSupplierFilter_Enum: FILTER_OPTIONS?.NONE, FilterText_List: [] }
        ]) : JSON.stringify(myMspTableData?.MSPSupplierFilter_List ?? [{ MSPSupplierFilter_Enum: FILTER_OPTIONS?.NONE, FilterText_List: [] }]),
        accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
        ClientSort: 'Company',
        IsArchived: false,
        ClientSortOrder: data?.order ?? sortOrder ?? 1,
        MSPClientSortVisibility_List: data?.visibilityList ?? JSON.stringify(myMspTableData?.MSPClientSortVisibility_List ?? []),
        IsClientSortChanged: true,
        pageSize: 10
      }
    });
  };

  useEffect(() => {
    if (isTyping === false) {
      setLoading(true);
      getMSPAllSupplierManufacturer({ filters: filters })
    }
  }, [searchString, isTyping])


  let timer;
  const timeoutVal = 1000;

  function handleKeyPress(e) {
    window.clearTimeout(timer);
    setIsTyping(true);
  }

  function handleKeyUp(e) {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      setIsTyping(false);
    }, timeoutVal);
  }

  return (
    <div className="supplierAndManufacturers transparent-scroller w-100" style={{ overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none', height: !loading && '100%' }}
      ref={divRef} /*onScroll={() => { handleScroll(); }}*/>
      <PageHeader
        isView={isView}
        selectedTab={selectedTab}
        setSelectedTab={(tab) => {
          setSelectedTab(tab);
          setPageNumber(0);
        }}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        headersList={headersList}
        filters={filters}
        setFilters={setFilters}
        getMSPAllSupplierManufacturer={getMSPAllSupplierManufacturer}
        onAddClick={() => {
          setIsView(false);
          setShowAddEditSupplierAndManufacturersModal(true);
        }}
        onSetOrderData={(updatedData) => {
          getMSPAllSupplierManufacturer({ visibilityList: JSON.stringify(updatedData), number: 0 });
          setHeadersList(updatedData);
        }}
        searchString={searchString}
        setSearchString={setSearchString}
        handleKeyPress={handleKeyPress}
        handleKeyUp={handleKeyUp}
        isSearchDisabled={showAddEditSupplierAndManufacturersModal}
      />
      {
        loading ? <SupplierAndManufacturerLoader /> : <>
          <PageBody
            isView={isView}
            pageType={selectedTab}
            data={myMspTableData}
            headersList={headersList}
            searchString={searchString}
            sortOrder={sortOrder}
            pageNumber={suppliersAndManufacturersList?.SupplierNumber === 0 ? Math.ceil(suppliersAndManufacturersList?.TotalSupplier / 10) : getFirstDigit(suppliersAndManufacturersList?.SupplierNumber)}
            maxPageNumber={Math.ceil(suppliersAndManufacturersList?.TotalSupplier / 10)}
            onPageButtonClick={(number) => { onPageClick(number); }}
            onArrowButtonClick={(isNext) => { onArrowClick(isNext); }}
            setSortOrder={setSortOrder}
            getMSPAllSupplierManufacturer={getMSPAllSupplierManufacturer}
            setHeadersList={setHeadersList}
            onItemClick={(id, clientId) => {
              setIsView(true);
              setShowAddEditSupplierAndManufacturersModal(true);
              setSelectedItemId(id);
              setSelectedItem(myMspTableData?.MSPSupplierManufacturer_List?.find(obj => obj?.SupplierId === id));
              setSelectedClientId(clientId);
            }}
            onAddClick={(id) => {
              setSelectedClientId(id);
              setIsView(false);
              setShowAddEditSupplierAndManufacturersModal(true);
            }}
          />

          <AddEditSupplierAndManufacturers
            show={showAddEditSupplierAndManufacturersModal}
            isView={isView}
            itemId={selectedItemId}
            IsPsaSupplier={selectedItem?.IsPsaSupplier}
            clientId={selectedClientId}
            isForClient={selectedTab?.pageId === 1}
            updateList={() => {
              getMSPAllSupplierManufacturer(
                {},
                myMspTableData?.MSPSupplierManufacturer_List?.findIndex((obj) => obj?.SupplierId === selectedItemId) < 20 ?
                  0 : myMspTableData?.MSPSupplierManufacturer_List?.findIndex((obj) => obj?.SupplierId === selectedItemId));
            }}
            hideModal={(isChanges = false) => {
              setShowAddEditSupplierAndManufacturersModal(false);
              if (isChanges) {
                getMSPAllSupplierManufacturer(
                  {},
                  myMspTableData?.MSPSupplierManufacturer_List?.findIndex((obj) => obj?.SupplierId === selectedItemId) < 20 ?
                    0 : myMspTableData?.MSPSupplierManufacturer_List?.findIndex((obj) => obj?.SupplierId === selectedItemId));
              }
              setSelectedItemId(0);
              setSelectedItem({});
              setSelectedClientId(0);
            }}
          />
        </>
      }
    </div>
  );
};

export default SupplierAndManufacturers;

export function getPageByItemCount(itemCount, itemsPerPage = 10) {
  return Math.ceil(itemCount / itemsPerPage);
}

function getFirstDigit(num) {
  num = Math.abs(num);
  if (num >= 10) {
    num = Math.floor(num / 10);
  }
  return num;
}

const SupplierAndManufacturerLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={"100%"}
      height={"100%"}
      viewBox="0 0 1500 900"
      backgroundColor="#F6F8FB"
      foregroundColor="#ecebeb"
    >
      <rect x="0" y="15" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="55" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="95" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="135" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="175" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="215" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="255" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="295" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="335" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="375" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="415" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="455" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="495" rx="3" ry="3" width="100%" height="33" />
      <rect x="0" y="535" rx="3" ry="3" width="100%" height="33" />
    </ContentLoader>
  );
};